export default __webpack_public_path__ + "static/media/Group.7f22ad97.jpg";